import React from "react";

export const Chevron = ({ rotated = false }: { rotated?: boolean, }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={rotated ? "rotate-180" : undefined}
  >
    <path d="M1 1L7 7L13 1" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

interface FilterDropdownButtonProps {
  label: string;
  isOpen: boolean;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
  onClick: () => void;
}

const FilterDropdownButton: React.FC<FilterDropdownButtonProps> = ({
  label,
  isOpen,
  buttonRef,
  onClick,
}) => (
  <div className="relative dropdown-wrapper shrink-0">
    <button
      ref={buttonRef}
      className="px-[8px] py-[4px] min-w-[75px] min-h-[26px] md:p-[8px] md:min-w-[87px] md:min-h-[36px] border border-gray-200 rounded-md font-rubik font-normal text-[12px] md:text-[14px] leading-5 text-center bg-white cursor-pointer whitespace-nowrap flex items-center md:gap-[8px] gap-[12px] space-between"
      onClick={onClick}
    >
      {label}
      <span className="pointer-events-none md:w-[18px] md:h-[18px] flex items-center justify-center">
        <Chevron rotated={isOpen} />
      </span>
    </button>
  </div>
);

export default FilterDropdownButton;
